import React from 'react';
import { Tooltip } from '../Tooltip/Tooltip';

interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
    /** Explanatory copy for the option, surfaced as a custom-styled tooltip on the whole label. */
    description?: string;
}

export const Radio: React.FC<RadioProps> = ({
    className = '',
    label,
    description,
    disabled,
    ...props
}) => {
    const radioClasses = disabled
        ? 'accent-primary-500 cursor-not-allowed'
        : 'accent-accent-400 cursor-pointer';

    const labelClasses = disabled
        ? 'text-primary-700 cursor-not-allowed'
        : 'text-content cursor-pointer';

    return (
        <Tooltip content={description}>
            {(describedById) => (
                <label className={`flex items-center gap-s ${className}`}>
                    {/* The browser draws this control; the dark scheme is what turns its unchecked fill dark. */}
                    <input
                        type="radio"
                        className={`w-[19px] h-[19px] touch-target rounded-full dark:scheme-dark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-focus-ring ${radioClasses}`}
                        disabled={disabled}
                        aria-describedby={describedById}
                        {...props}
                    />
                    {label && (
                        <span className={`text-compact font-medium ${labelClasses}`}>
                            {label}
                        </span>
                    )}
                </label>
            )}
        </Tooltip>
    );
};